import { SUPPORTED_FILE_TYPES } from 'web-ui-kit/messenger-consts';
import { ALSO_HAS_ACCEPTED_MESSAGE, BAD_FILE_TYPES_MESSAGE } from './consts';

/**
 * Generates the error message given bad files types and number of accepted files
 * @param numAccepted - The number of files that were accepted
 * @param badMimes - the mime type of all the rejected files, such as 'text/csv'
 */
export const generateFileUploadError = ({
  badMimes = [],
  numAccepted = 0
}) => {
  // Early exit, allows resetting the string to a falsy value
  if (!badMimes || badMimes.length < 1) {
    return '';
  }
  const fileTypes = [...new Set(badMimes.map(mime => `.${mime.split('/')[1]}`))];
  const fileTypesString = generateRejectedFileTypesString(fileTypes);
  let message = BAD_FILE_TYPES_MESSAGE(fileTypesString, SUPPORTED_FILE_TYPES);
  if (numAccepted) {
    message += ALSO_HAS_ACCEPTED_MESSAGE;
  }
  return message;
};

/**
 * Generates the file rejected types string in the formats
 * 1 item: returns the file type
 * 2 items returns fileType and fileType
 * 3+ items returns fileType, fileType, ..., and fileType
 * @param fileTypes - List of file types such as .txt, .mp4, etc...
 */
const generateRejectedFileTypesString = (fileTypes) => {
  switch (fileTypes.length) {
    case 0:
      return '';
    case 1:
      return fileTypes[0];
    case 2:
      return `${fileTypes[0]} and ${fileTypes[1]}`;
    default:
      let typesString = '';
      fileTypes.forEach((fileType, index) => {
        if (index === fileTypes.length - 1) {
          typesString += `and ${fileType}`;
        } else {
          typesString += `${fileType}, `;
        }
      });
      return typesString;
  }
};

/**
 *  Returns expected value for hidden on a message based on visibility
 */
export const getVisibilityForUser = ({ isAdmin, message, userId }) => {
  let hidden = false;

  switch (message.visibility) {
    case 0:
    case null:
    case undefined:
      hidden = false;
      break;
    case -1:
      hidden = !isAdmin;
      break;
    case -2:
      hidden = userId !== null;
      break;
    default:
      hidden = userId !== message.visibility;
      break;
  }

  return hidden || message.hidden;
};
